<template>
  <div>
    <v-col cols="12" class="mx-auto">
      <div class="mx-auto">
        <v-btn
          color="primary"
          :disabled="selectedDevices.length < 1 && !isOldDevice"
          outlined
          class="text-none mr-2"
          rounded
          @click="getPossibleDoorphones"
        >
          привязать домофон
        </v-btn>
      </div>

      <v-dialog v-model="popupBindDoorphones" max-width="700" lazy-validation>
        <v-card class='pb-2'>
          <v-card-title class="headline">
            Привязать домофон
            <v-spacer></v-spacer>
            <v-btn
              icon
              text
              x-large
              class="btn__icon pa-0"
              width="18"
              height="18"
              @click.prevent="popupBindDoorphones = false"
            >
              <v-icon size="x-large">mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-col class="px-5 pb-1 pt-1">
            <v-text-field
              v-model='serchValue'
              placeholder="Поиск по адресу"
              solo
              outlined
              dense
              hide-details
              flat
            ></v-text-field>
          </v-col>
          <v-col class="px-5 pb-1">
            <v-text-field
              v-model='serchValueId'
              placeholder="Поиск по id"
              solo
              outlined
              dense
              hide-details
              flat
            ></v-text-field>
          </v-col>
          <v-col class="px-5 pt-0 pb-0" v-if="isGateDoorphone && isMultiDoorphones">
            <div class="body-2 grey--text text--darken-1">
              Можно выбрать максимум 10 домофонов
            </div>
          </v-col>
          <v-row class="pa-4 px-5">
            <v-col>
              <v-btn
                color="green"
                outlined
                class="text-none mr-2"
                rounded
                @click.prevent="addDoorphone()"
              >
                Привязать
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn
                dark
                class="btn primary darken-3 white px-7 text-none"
                @click="filterDoorphones"
              >
                Поиск
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            class="table row-click mx-5 pb-5"
            :items-per-page="10"
            :items="doorphonesArray"
            :options.sync="options"
            :server-items-length="totalDoorphones"
            :headers="headersTieDoorphones"
            item-key="id"
            show-select
            :loading="loadingListDoorphones"
            :multi-select="isGateDoorphone && isMultiDoorphones"
            :single-select="isGateDoorphone && !isMultiDoorphones"
            v-model="selected"
            @click:row="activateShowSelect"
            :footer-props="{
              'items-per-page-options': [10, 20, 50],
              showFirstLastPage: true,
            }"
          >
            <template v-slot:item.address="{ item }">
              {{ getDoorphoneAddress(item) }}
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>

      <v-dialog v-model="popupApartmentPrefix" persistent max-width="380">
        <v-card>
          <v-card-title>Установите префикс для квартир</v-card-title>
          <v-col>
            <v-text-field
              label="префикс для квартир"
              v-model.number="apartmentPrefix"
              :rules="[
                v => !!v || 'Обязательное поле',
                v => v >= 0 || 'Введите целое число',
            ]"
              type="number"
              outlined
              dense
              flat
              required
            ></v-text-field>
          </v-col>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              text
              @click="addPrefix(apartmentPrefix)"
              :disabled="apartmentPrefix === ''"
            >
              добавить
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <h2 class="ma-3">{{ doorphoneText }}</h2>
      <v-data-table
        class="table"
        :headers="headers"
        :items="selectedDoorphones"
        v-if ="selectedDoorphones.length > 0"
        :disable-sort="true"
        hide-default-footer
      >
        <template v-slot:item.address="{ item }">
          {{ item.address }}
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row justify="center" class="flex-nowrap">
            <v-btn
              icon
              text
              small
              class="btn__icon pa-0"
              width="18"
              height="18"
              @click.prevent="deleteDoorphone(item)"
            >
              <v-icon size="large">mdi-close</v-icon>
            </v-btn>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'BaseNewBindingDoorphone',
  props: {
    isGateDoorphone: {
      type: Boolean,
      default: false,
    },
    isWithoutPrefix: {
      type: Boolean,
    },
    isMultiDoorphones: {
      type: Boolean,
      default: false,
    },
    isOldDevice: {
      type: Boolean,
    },
    selectedDevices: {
      type: Array,
    },
    isFiltersManufacturer: {
      type: Boolean,
      default: true,
    },
  },
  data: () => {
    return {
      loading: false,
      address: '',
      selected: [],
      doorphones: [],
      doorphonesArray: [],
      filters: { type: 'M' },
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 10,
      },
      isCreated: false,
      selectedDoorphones: [],
      serchValue: '',
      serchValueId: '',
      popupBindDoorphones: false,
      loadingListDoorphones: false,
      popupApartmentPrefix: false,
      isPrefix: false,
      apartmentPrefix: '',
      totalDoorphones: 0,
      headersTieDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: 'Модель', value: 'device.model', sortable: false },
      ],
      headersDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: '', value: 'actions' },
      ],
      headersGateDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: 'Префикс', value: 'apartment_prefix' },
        { text: '', value: 'actions' },
      ],
      include: ['device'],
    };
  },
  created () {
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
    selected (newVal) {
      if (this.isGateDoorphone && this.isMultiDoorphones && Array.isArray(newVal) && newVal.length > 10) {
        this.selected = newVal.slice(0, 10);
        this.$flash_danger('Можно выбрать максимум 10 домофонов');
      }
    },
  },
  computed: {
    ...mapGetters({
      barrierEdit: 'Barriers/barrierEdit',
      doorphonesArrays: 'Doorphone/doorphonesExpanded',
      roleName: 'roleName',
    }),
    headers () {
      if (this.isGateDoorphone) {
        return this.headersGateDoorphones;
      } else {
        return this.headersDoorphones;
      }
    },
    doorphoneText () {
      if (this.selectedDoorphones.length > 1) {
        return 'Домофоны';
      }
      if (this.selectedDoorphones.length === 1) {
        return 'Домофон';
      }
      return '';
    },
    displayCardText () {
      switch (this.barrierEdit.barrier.passage_type) {
        case 'B': return 'Привязанные домофоны к шлагбауму.';
        case 'G': return 'Привязанные домофоны к воротам.';
        default: return 'Привязанные домофоны.';
      }
    },
  },
  methods: {
    ...mapActions({
      getDoorphones: 'Doorphone/getExpandedDoorphones',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    activateShowSelect (value) {
      if (!this.isGateDoorphone) {
        const index = this.selected.indexOf(value);

        if (index === -1) {
          this.selected.push(value);
        } else {
          this.selected.splice(index, 1);
        }
        this.isDisabled = this.selected.length === 0;
      }
    },
    async getPossibleDoorphones () {
      this.filters = { type: 'M' };
      if (this.isFiltersManufacturer && this.selectedDevices.length > 0) {
        this.filters.manufacturer = this.selectedDevices[0].manufacturer;
      }
      await this.loadDoorphones();

      this.popupBindDoorphones = true;
    },
    async addDoorphone () {
      if (this.selected[0]) {
        this.doorphones.push(this.selected);
        if (!this.isWithoutPrefix && this.isGateDoorphone) {
          if (this.isMultiDoorphones) {
            await this.additionSelectWithAutoPrefixes();
          } else {
            this.popupApartmentPrefix = true;
            this.apartmentPrefix = this.selected[0].apartmentPrefix;
          }
        } else {
          await this.additionSelect();
        }
      } else {
        this.$flash_danger('Выберите домофон');
      }
    },

    addPrefix (apartmentPrefix) {
      const doorphones = this.doorphones[this.doorphones.length - 1].slice();

      const newSelectedDoorphones = doorphones.map(doorphone => ({
        id: doorphone.id,
        address: doorphone.address,
        apartment_prefix: apartmentPrefix,
      }));
      this.selectedDoorphones = [...this.selectedDoorphones, ...newSelectedDoorphones];
      this.$emit('addGateDoorphones', newSelectedDoorphones);

      this.cancelBindDoorphone();
    },

    additionSelect () {
      const doorphones = this.doorphones[this.doorphones.length - 1].slice();
      const newSelectedDoorphones = doorphones.map(doorphone => ({
        id: doorphone.id,
        address: doorphone.address,
      }));

      this.selectedDoorphones = [...this.selectedDoorphones, ...newSelectedDoorphones];
      const doorphoneIds = this.selectedDoorphones.map(doorphone => doorphone.id).join(',');
      const doorphoneIdsArray = doorphoneIds.split(',').map(id => id.trim());
      this.$emit('addDoorphones', doorphoneIdsArray);

      this.cancelBindDoorphone();
    },
    additionSelectWithAutoPrefixes () {
      const doorphones = this.doorphones[this.doorphones.length - 1].slice();
      const newSelectedDoorphones = doorphones.map(doorphone => ({
        id: doorphone.id,
        address: doorphone.address,
        apartment_prefix: String(doorphone.apartmentPrefix || '').replace(/\D+/g, ''),
      }));
      this.selectedDoorphones = [...this.selectedDoorphones, ...newSelectedDoorphones];
      this.$emit('addGateDoorphones', newSelectedDoorphones);

      this.cancelBindDoorphone();
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    async deleteDoorphone (item) {
      this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => doorphone.id !== item.id);
      if (this.isGateDoorphone) {
        this.$emit('deleteGateDoorphones', this.selectedDoorphones);
      } else {
        this.$emit('deleteDoorphones', item);
      }
    },
    cancelBindDoorphone () {
      this.popupBindDoorphones = false;
      this.popupApartmentPrefix = false;
      this.loading = false;
      this.selected = [];
      this.value = '';
      this.serchValue = '';
      this.serchValueId = '';
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { type: 'M' };

      if (this.isFiltersManufacturer && this.selectedDevices.length > 0) {
        this.filters.manufacturer = this.selectedDevices[0].manufacturer;
      }

      if (this.serchValue) {
        this.filters.address = this.serchValue;
      }
      if (this.serchValueId) {
        this.filters.id = this.serchValueId;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
      this.loadDoorphones();
    },
    async loadDoorphones () {
      await this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
        include: this.include,
      })
        .then((data) => {
          this.loading = false;
          this.totalDoorphones = data.meta.total;
          this.doorphonesArray = data.doorphones
            .map((doorphone) => {
              doorphone.apartmentPrefix = doorphone.address.split(', д.').pop().replace(/\D+/g, '');
              return doorphone;
            })
            .filter((doorphone) => {
              const isNotSelected = !this.selectedDoorphones.some(selected => selected.id === doorphone.id);
              const hasDeviceId = this.isFiltersManufacturer ? !!doorphone.device_id : true;
              return isNotSelected && hasDeviceId;
            });
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при загрузке домофонов');
        })
        .finally(() => {
          this.loadingListDoorphones = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

.row-click {
  cursor: pointer;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
